import { Booking, Metadata, Note } from '@deliveries-app/models';

export enum BookingActionTypes {
  BOOKING_REQUEST = 'bookings/BOOKING_REQUEST',
  GET_ALL_BOOKINGS_SUCCESS = 'bookings/GET_ALL_BOOKINGS_SUCCESS',
  GET_ALL_BOOKINGS_FAILURE = 'bookings/GET_ALL_BOOKINGS_FAILURE',
  CREATE_BOOKING_SUCCESS = 'bookings/CREATE_BOOKING_SUCCESS',
  CREATE_BOOKING_FAILURE = 'bookings/CREATE_BOOKING_FAILURE',
  UPDATE_BOOKING_SUCCESS = 'bookings/UPDATE_BOOKING_SUCCESS',
  UPDATE_BOOKING_FAILURE = 'bookings/UPDATE_BOOKING_FAILURE',
  DELETE_BOOKING_SUCCESS = 'bookings/DELETE_BOOKING_SUCCESS',
  DELETE_BOOKING_FAILURE = 'bookings/DELETE_BOOKING_FAILURE',
  CREATE_BOOKING_NOTE_SUCCESS = 'bookings/CREATE_BOOKING_NOTE_SUCCESS',
  CREATE_BOOKING_NOTE_FAILURE = 'bookings/CREATE_BOOKING_NOTE_FAILURE',
}

export type BookingActions =
  | { type: BookingActionTypes.BOOKING_REQUEST }
  | {
      type: BookingActionTypes.GET_ALL_BOOKINGS_SUCCESS;
      payload: {
        data: Booking[];
        _metadata: Metadata;
      };
    }
  | { type: BookingActionTypes.GET_ALL_BOOKINGS_FAILURE; payload: string }
  | { type: BookingActionTypes.CREATE_BOOKING_SUCCESS; payload: Booking }
  | {
      type: BookingActionTypes.CREATE_BOOKING_FAILURE;
      payload: {
        error: string;
        errors: string[];
      };
    }
  | {
      type: BookingActionTypes.UPDATE_BOOKING_SUCCESS;
      payload: { id: number; completed: boolean };
    }
  | {
      type: BookingActionTypes.UPDATE_BOOKING_FAILURE;
      payload: {
        error: string;
        errors: string[];
      };
    }
  | { type: BookingActionTypes.DELETE_BOOKING_SUCCESS; payload: number }
  | { type: BookingActionTypes.DELETE_BOOKING_FAILURE; payload: string }
  | {
      type: BookingActionTypes.CREATE_BOOKING_NOTE_SUCCESS;
      payload: { booking_id: number; note: Note };
    }
  | {
      type: BookingActionTypes.CREATE_BOOKING_NOTE_FAILURE;
      payload: string;
    };
